@if (!!selectedItem) {
<div class="image-wrapper">
    <div class="image">
        <img
                class="preview_image"
                [src]="imageData"
                [alt]="'dashcam preview'"
                (error)="onImageError()"
                (load)="onImageLoad()"
                [hidden]="imageError"
        />
        @if (loadingImage) {
          <mat-spinner
                       class="spinner"
                       [diameter]="16"
          ></mat-spinner>
        }
        @if (!imageError && imageData) {
          <div class="image-actions">
            <button mat-icon-button (click)="openImageInNewTab()" matTooltip="Open in new tab">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button mat-icon-button (click)="downloadImage()" matTooltip="Download image">
              <mat-icon>download</mat-icon>
            </button>
          </div>
        }
    </div>

    <div class="image-info">
        <span>{{ selectedItem.time | date:'short' }}</span>
        @if (images.length > 1) {
          <span>{{ positionString }}</span>
        }
    </div>

    @if (images.length > 1) {
      <div class="image-controls">
          <button mat-icon-button
                  (click)="previousImage()"
          >
              <mat-icon>west</mat-icon>
          </button>
          <button mat-icon-button
                  (click)="nextImage()"
          >
              <mat-icon>east</mat-icon>
          </button>
      </div>
    }
</div>
}
